import {Component, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, NgControl } from '@angular/forms';
import { NumericTextboxModel } from '../numeric-textbox.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { FORMAT_NUMBER } from 'src/app/app.models';
import { createMask, InputmaskOptions } from '@ngneat/input-mask';
import * as numeral from 'numeral';
import { takeUntil } from 'rxjs/operators';
import { Options } from 'inputmask';

@Component({
    selector: 'abw-numeric-textbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NumericTextboxFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => NumericTextboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './numeric-textbox-form.component.html',
    styleUrls: ['./numeric-textbox-form.component.scss']
})
export class NumericTextboxFormComponent extends AbstractWorkflowFormComponent<NumericTextboxModel, string> implements OnInit, OnChanges {
  FORMAT_NUMBER = FORMAT_NUMBER;
  inputMaskConfig: InputmaskOptions<any>;
  numericValue: number;
  inputModeNumeric: { [key: string]: string } = { inputmode: "numeric" };
  formatedValue = '';

  ngOnInit() {
      super.ngOnInit();
      this.inputMaskConfig = createMask({
        alias: 'numeric',
        groupSeparator: this.model.numberFormat == FORMAT_NUMBER.CURRENCY ? ' ' : '',
        radixPoint: ',',
        digits: '2',
        digitsOptional: true,
        prefix: '',
        placeholder: '0',
        rightAlign: false,
        onBeforeMask: (initialValue: string, opts: Options) => {
          return initialValue;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.value && changes.value.currentValue !== undefined)  {
      this.numericValue = !!changes.value.currentValue ? parseFloat(changes.value.currentValue.toString().replace(/\s/g, "").replace(",", ".")) : null;
    }
  }

  writeValue(value: any) {
    const numericValue: number = value !== undefined ? parseFloat(value.toString().replace(/\s/g, "").replace(",", ".")) : null;
    this.value = numericValue; 
    this.numericValue = numericValue;

    if (value !== undefined) {
      const parts = value.toString().split(",");
      const partsWhole = parts[0];
      const partsDecimal = parts.length > 1 ? "," + parts[1] : ""; 
      const partsWholeFormat = partsWhole.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      const partsDecimalFormat = partsDecimal;
      this.formatedValue = partsWholeFormat + partsDecimalFormat;
    }
  }
  
	validate({ value }: FormControl) {
    const numericValue: number = !!value ? parseFloat(value.toString().replace(/\s/g, "").replace(",", ".")) : null;
		const isValid = (this.model as any).required && (isNaN(numericValue) || numericValue === 0);
		return isValid && {
		  	invalid: true
		};
	}

  onChanged(_event) {
    const value = _event.target.value;
    this.onValueChanged((!!value ? numeral((value + '').replace(',', '.')).value() : null) + '');
  }

  onValueChanged(_value: any, _emitValue?: boolean, _callersStack?: string[]) {
    const numericValue: number = !!_value ? parseFloat(_value.toString().replace(/\s/g, "").replace(",", ".")) : null;
    this.value = !isNaN(numericValue) ? numericValue : 0; 
    this.numericValue = !isNaN(numericValue) ? numericValue : 0; 
    this.propagateChange(this.value);
    try { this._cdf.detectChanges(); } catch(ex) {}
    this.change.emit(this.value);
    if (!!this.model && (_emitValue === undefined || _emitValue === true)) {
      this.emitValue(_callersStack);
    }
  }

  onKeydown(_event) {
    const allowKey = ["-", "Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
    const allowNumber = /[0-9]/.test(_event.key);
    const separator = _event.key === "." || _event.key === ","; 
    if (!allowNumber && !allowKey.includes(_event.key) && !separator) {
        _event.preventDefault();
    }
    if (separator && (_event.target.value.includes(".") || _event.target.value.includes(","))) {
        _event.target.preventDefault();
    }
  }

  onInput(_event) {
    let inputValueProcess = _event.target.value.replace(/\s/g, ""); 
    inputValueProcess = inputValueProcess.replace(".", ",");
    if (!/^-?\d*[\.,]?\d*$/.test(inputValueProcess)) return;
    const inputValueRaw = inputValueProcess.replace(",", ".");
    const rawValueAsNumber = parseFloat(inputValueRaw); 
    if (!isNaN(rawValueAsNumber)) {
      _event.target.dataset.rawValue = rawValueAsNumber;
    }

    const parts = inputValueProcess.split(",");
    const partsWhole = parts[0];
    const partsDecimal = parts.length > 1 ? "," + parts[1] : ""; 
    const partsWholeFormat = partsWhole.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const partsDecimalFormat = partsDecimal;
    this.formatedValue = partsWholeFormat + partsDecimalFormat;
  }
}